import {ScrollableTableRow} from 'ui-library/scrollable/ScrollableTableConstants';

/**
 * Check if the row index is out of bounds for a list of rows.
 *
 * This check is necessary due to a bug in fixed-data-table-2. fixed-data-table-2 has a lot of special
 * logic to buffer the row rendering for performance reasons. When a row is removed and the user is
 * scrolling, the rows gets momentarily out of sync with the buffer of rows it maintains. We need to guard
 * against out of bounds indices to avoid crashing when trying to reference a row that no longer exists.
 *
 * See BNCH-13143 for more info.
 */
export default function isRowIndexOutOfBounds(rows: Array<ScrollableTableRow>, rowIndex: number): boolean {
  return rowIndex >= rows.length;
}
